import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { AgreementBody } from "@/components/ProTermsModal";
import { Scale, ArrowLeft } from "lucide-react";

// Route slug → the canonical agreement key in backend/legal_content.py. The
// page renders that exact document, so the text a user reads is the same
// version string recorded in `legal_acceptances`.
const KEY_BY_SLUG = {
  terms: "terms_of_use",
  privacy: "privacy_policy",
  membership: "membership_terms",
  billing: "membership_terms",
};

export default function LegalDoc() {
  const { slug } = useParams();
  const key = KEY_BY_SLUG[slug];
  const [doc, setDoc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!key) { setFailed(true); return; }
    api.get(`/legal/${key}`).then(r => setDoc(r.data)).catch(() => setFailed(true));
  }, [key]);

  return (
    <div className="bg-[#F5F7F5] min-h-screen">
      <Header/>
      <div className="max-w-3xl mx-auto px-6 py-14" data-testid={`legal-doc-${slug}`}>
        <Link to="/legal" className="inline-flex items-center gap-1.5 text-sm text-[#245544] font-semibold mb-5 hover:underline" data-testid="legal-doc-back">
          <ArrowLeft size={15}/> Legal &amp; policies
        </Link>
        <span className="flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#E1EDE7] text-[#245544] text-xs font-bold uppercase tracking-wider mb-4 w-fit">
          <Scale size={13}/> Legal
        </span>
        <h1 className="text-4xl sm:text-5xl font-bold text-[#2D2926] mb-6" style={{ fontFamily: "Outfit" }}>
          {doc?.title || (failed ? "Document not found" : "Loading…")}
        </h1>
        <div className="bg-white border border-black/[0.07] rounded-2xl p-6 sm:p-8">
          {doc
            ? <AgreementBody doc={doc}/>
            : <p className="text-sm text-[#2D2926]/55">{failed ? "We couldn't load this document. Please try again." : "Loading…"}</p>}
        </div>
        <p className="text-sm text-[#5C554E] mt-8">
          Questions about these policies? <Link to="/contact" className="text-[#245544] font-semibold underline" data-testid="legal-doc-contact-link">Get in touch</Link>.
        </p>
      </div>
      <Footer/>
    </div>
  );
}
